import { createI18n } from 'vue-i18n';

import de from './de';
import en from './en';
// import dateTimeFormats from "./dateTimeFormats";

const locale = localStorage?.getItem('locale')?.toLowerCase() ?? 'de';

// Type-define 'de' as the master schema for the resource
type MessageSchema = typeof de;

const messages = {
  en,
  de,
};

//Create i18n instance
const i18n = createI18n<MessageSchema, 'de' | 'en'>({
  locale: locale,
  fallbackLocale: 'en',
  messages: messages,
  globalInjection: true, //necessary? Should allow for the use of $t() everywhere.
  legacy: false, //necessary?
});

export default i18n;
